/**
 * The composer textarea's DOM id. Its own module because half a dozen surfaces
 * outside `input/` reach the element by id (focus intent, the quick tour's
 * anchor, dictation's cursor-to-end event) and must not pull the component in.
 */
export const ChatInputElementId = 'message-input'
